import classNames from 'classnames';
import React from 'react';

export default ({ fields, highlight }) => {
  const keyDocument = fields.key_document?.[0] === true;
  const archived = fields.archived?.[0] === true;

  return (
    <span className='related-links'>
    <span className="display-id-wrapper">
      <span className={`fa fa-fw ${fields.icon} mr-2`} />
      <span className="display-id">
        {fields.filename}
      </span>
      {keyDocument && <span className="ml-2" title="Key file" aria-label="Key file">⭐</span>}
      {archived && <span className="badge badge-warning ml-2">Archived</span>}
    </span>
    <MatchedTextContent highlight={highlight?.content} />
  </span>
  );
}

const MatchedTextContent = ({ highlight }) => {

  if (!highlight || !Array.isArray(highlight) || !highlight[0]) {
    return null;
  }

  const parts = highlight[0].split('<%#%>');

  return (
    <div className="comment-snippet smallish">
      <i className="fa fa-quote-left mr-2" title="Comment"></i>
      {
        parts.map(
          (part, idx) => {

            return (
              <span
                className={classNames({ 'highlighted': idx % 2 !== 0 })}
                key={idx}
              >
                {part}
              </span>
            );
          }
        )
      }
    </div>
  );

}
